module.exports = __webpack_public_path__ + "media/angular-engine/app/signup/account-type/create-6ac6013a6cd3177d01735ed8cbd61d44.svg";